import Icon from "../Icon";

const DotList = (props) => {
  return (
    <>
      <div className="h-100 border-end position-relative">
        <Icon
          name="timelineStep"
          className="position-absolute"
          style={{ fontSize: 25, right: -13, top: -4 }}
        />
      </div>
    </>
  );
};

export default DotList;
